import React from 'react'

const WalletData = props => {
    let { subscribeData } = props
    let { investor_balance } = subscribeData
    let translation = JSON.parse(localStorage.translation)[
        localStorage.language
    ]

    return (
        <div>
            <div className="subscribe__margin-bottom_s">
                <p className="subscribe__text-size_m">{firstLetterUppercase(translation['address'])}</p>
                <p className="subscribe__desc subscribe__desc_blue subscribe__text-ofh">
                    0xf2bb62694994b5347136df13e7a15745e5b26482
                </p>
            </div>
            <div className="subscribe__margin-bottom_s">
                <p className="subscribe__text-size_m">{firstLetterUppercase(translation['balance'])}</p>
                <p className="subscribe__desc">{`${investor_balance} CPT`}</p>
            </div>
        </div>
    )
}

const firstLetterUppercase = str => {
    return (
        str.replace(/[^a-z||^a-я]/gi, ' ')[0].toUpperCase() +
        str.replace(/[^a-z||^a-я]/gi, ' ').slice(1)
    )
}

export default WalletData
